import { observable, makeObservable, runInAction } from 'mobx';
import { getZReport, getZReportHistory } from '../api/admin';
import CashRegister from '../model/CashRegister';
import ZReport from '../model/ZReport';
import CompanyStore from './CompanyStore';

class CashRegisterStore {
  companyStore: CompanyStore;

  list: CashRegister[] = [];

  zReportHistory: ZReport[] = [];

  isLoadingZHistory = false;

  errorMessage = '';

  constructor(companyStore: CompanyStore) {
    this.companyStore = companyStore;
    makeObservable(this, {
      list: observable,
      zReportHistory: observable,
      isLoadingZHistory: observable,
      errorMessage: observable,
    });
  }

  async getZReportHistory() {
    if (!this.companyStore.companyKey) {
      return;
    }

    runInAction(() => {
      this.zReportHistory = [];
      this.errorMessage = '';
      this.isLoadingZHistory = true;
    });

    const data = await getZReportHistory(this.companyStore.companyKey)
      .then(async (res) => {
        const promises = res.reports.map(async (report) => {
          const zReport = await this.fetchZReportById(report.id);
          return {
            id: report.id,
            time: report.time,
            rows: (zReport?.report?.csv ?? '').split('\n').map((row: string) => row.split(';')),
          };
        });
        return Promise.all(promises);
      })
      .catch(() => {
        runInAction(() => {
          this.setErrorMessage('Misslyckades med att hämta z-historik');
          this.isLoadingZHistory = false;
        });
      })
      .finally(() => {
        runInAction(() => {
          this.isLoadingZHistory = false;
        });
      });
    runInAction(() => {
      this.zReportHistory = data || [];
    });
  }

  fetchZReportById(reportId: string) {
    const report = getZReport(this.companyStore.companyKey, reportId);
    return report;
  }

  refreshZReportHistory() {
    if (this.isLoadingZHistory) {
      return;
    }
    runInAction(() => {
      this.zReportHistory = [];
      this.errorMessage = '';
    });
    this.getZReportHistory();
  }

  setErrorMessage(message: string) {
    this.errorMessage = message;
  }
}
export default CashRegisterStore;
